import ElevenLabsLogo from '@shared/assets/icons/ic-elevenlabs.png'
import LiveKitLogo from '@shared/assets/icons/ic-livekit.png'
import OpenAiLogo from '@shared/assets/icons/ic-openai.png'
import RetellLogo from '@shared/assets/icons/ic-retell.png'
import VapiLogo from '@shared/assets/icons/ic-vapi.png'
import XaiLogo from '@shared/assets/icons/ic-xai.png'
import { Phone } from 'lucide-react'
import type { SipPlatformKey } from './platform-config'

const PLATFORM_LOGO_SRC: Partial<Record<SipPlatformKey, string>> = {
  livekit: LiveKitLogo,
  retell: RetellLogo,
  vapi: VapiLogo,
  elevenlabs: ElevenLabsLogo,
  xai: XaiLogo,
  openai: OpenAiLogo,
}

/**
 * 20px tile for the SIP platform dropdown. The named platforms ship their tile
 * inside the PNG. Custom has no brand mark, so it gets a plain handset glyph and
 * NO tile chrome, which is what keeps it visually distinct from the four branded
 * squares. It was a pencil first, which read as "edit" rather than "your own SIP
 * platform" (Venky, 2026-08-05), then briefly sliders.
 */
export const PlatformLogo = ({ platform }: { platform: SipPlatformKey }) => {
  const src = PLATFORM_LOGO_SRC[platform]

  if (src) {
    return <img src={src} alt={`${platform} logo`} className="h-5 w-5 flex-shrink-0 rounded" />
  }

  return (
    <span className="flex h-5 w-5 flex-shrink-0 items-center justify-center">
      <Phone className="h-4 w-4 text-secondary" />
    </span>
  )
}
